@if (data()) {
  <div class="d-flex flex-column align-items-center gap-big introduction-bottom-sheet-container">
    @if (data().image) {
      <img
        class="w-25"
        [src]="data().image"
        [alt]="data().title"
      />
    }
    <p class="text-align-center text-onback-high st-3">{{ data().title }}</p>
    <div class="d-flex flex-wrap position-relative content">
      <div class="d-flex flex-column gap-plus">
        @for (bullet of data().bullets; track $index) {
          <div class="stepper">
            <div class="bullet"></div>
            <span>
              {{ bullet }}
            </span>
          </div>
        }
      </div>
      @if (data().descriptions?.length > 0) {
        <div class="w-100 my-medium">
          @for (description of data().descriptions; track description; let i = $index) {
            @if (i === 1 && data().chartImage) {
              <div class="w-100">
                <img
                  class="w-100"
                  [src]="data().chartImage"
                  alt="chart"
                />
              </div>
            }
            <div class="mt-big">
              <span class="text-align-justify">{{ description }}</span>
            </div>
          }
        </div>
      }

      <div class="w-100 d-flex surface-elevated mt-big">
        <ngx-button
          [fullWidth]="true"
          mode="form"
          [size]="'medium'"
          (clickHandler)="close()"
        >
          متوجه شدم
        </ngx-button>
      </div>
    </div>
  </div>
}
